// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailedSelect_block__0Xk36 article-wrapper","text":"DetailedSelect_text__r_0sR","select":"DetailedSelect_select__PJ6Bl"};